import { useCallback, useRef, useState } from "react";

export const useOTPCountDown = () => {
  const [timeCount, setTimeCount] = useState<number>(0);
  const timeValueRef = useRef<number>(0);
  const refTimer = useRef<NodeJS.Timeout>();

  const countFrom = useCallback((from: number) => {
    timeValueRef.current = from;
    setTimeCount(from);
    if (refTimer.current) {
      clearInterval(refTimer.current);
    }
    refTimer.current = setInterval(() => {
      if (timeValueRef.current > 0) {
        timeValueRef.current -= 1;
      } else clearInterval(refTimer.current);
      setTimeCount((prev) => timeValueRef.current);
    }, 1000);
  }, []);

  return {
    time: timeCount,
    countFrom,
  };
};
